// extracted by mini-css-extract-plugin
export default {"body":"BestSellers_body__YqXdK"};